import { IBar, IScore } from "../../../../../common/types";

const getBarsOrder = (score: IScore, barPlay?: boolean) => {
    const bars: IBar[][] = [score.bars, score.bars1, score.bars2, score.bars3, score.bars4, score.bars5];
    const { barlines } = score;
    const hasUpbeat = !!bars[0][0];
    const lastBar =
        bars.reduce((num, bars) => {
            if (bars && bars.length > num) return bars.length;
            return num;
        }, 0) - 1;

    const order = [];
    let currentBar = hasUpbeat ? 0 : 1;
    let returnBar: number | null = currentBar;
    const usedRepeats = [];
    const usedRepeatBacks = [];
    while (currentBar !== lastBar) {
        order.push(currentBar);
        /* eslint-disable no-loop-func */
        const barline = barlines.find(bl => bl.bar === currentBar);
        const prevBarline = barlines.find(bl => bl.bar === currentBar - 1);
        if (
            !barPlay &&
            prevBarline &&
            usedRepeatBacks.indexOf(currentBar - 1) === -1 &&
            prevBarline.type &&
            (prevBarline.type.includes("RepeatStart") || prevBarline.type.includes("RepeatBoth"))
        ) {
            usedRepeatBacks.push(currentBar - 1);
            returnBar = currentBar;
        }
        if (
            !barPlay &&
            barline &&
            usedRepeats.indexOf(currentBar) === -1 &&
            barline.type &&
            (barline.type.includes("RepeatEnd") || barline.type.includes("RepeatBoth")) &&
            returnBar !== null
        ) {
            usedRepeats.push(currentBar);
            currentBar = returnBar;
            returnBar = null;
        } else {
            currentBar++;
        }
    }
    order.push(lastBar);
    return order;
};

export default getBarsOrder;
